export default "__VITE_ASSET__Dnt3XtgZ__"